import { useAtomValue } from "jotai";
import { paymentRefData, userProfile } from "../../state";
import styles from "./paymentReceipt.module.scss";
import { useNavigate } from "react-router-dom";
import { ReactComponent as BackArrow } from "../../assets/arrow-back.svg";
import { ReactComponent as Logo } from "../../assets/logo-small.svg";
import Button from "../../custom/button/button";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import { formatCurrency } from "../../utils/formatCurrency";
import EmptyState from "../../custom/emptyState/emptyState";
import { formatDate } from "../../utils/formatDate";
import { formatFullName } from "../../utils/stringHelpers";

const PaymentReceipt = () => {
  const navigate = useNavigate();
  const data = useAtomValue(paymentRefData);
  const profile = useAtomValue(userProfile);
  const receiptRef = useRef(null);
  const fullName = formatFullName(
    profile?.LastName,
    profile?.FirstName,
    profile?.MiddleName
  );

  const printReceipt = useReactToPrint({
    content: () => receiptRef.current,
    documentTitle: "Payment Receipt",
  });

  if (!data.PaymentReference) {
    return <EmptyState text="Receipt not available" />;
  }

  return (
    <div>
      <section className={styles.heading}>
        <div className={"headingWithBackArrow"}>
          <button onClick={() => navigate("/payment-history")}>
            <BackArrow />
          </button>
          <h3>Payment Receipt</h3>
        </div>
        <Button
          className={"outlineBtn"}
          onClick={printReceipt}
          text="Download Receipt"
        />
      </section>
      <br />
      <section ref={receiptRef} className={styles.receiptContainer}>
        <div className={styles.letterHead}>
          <div className="spaceBetween">
            <Logo className={styles.logo} />
            <h1>Receipt</h1>
          </div>
        </div>
        <br />
        <div className={styles.grid}>
          <div className={styles.receiptDetails}>
            <label>Payment Date</label>
            <h6>{formatDate(data.PaymentDate)}</h6>
          </div>
          <div className={styles.receiptDetails}>
            <label>Membership Number</label>
            <h6>{data.ApplicantId}</h6>
          </div>
          <div className={styles.receiptDetails}>
            <label>Member Name</label>
            <h6>{fullName || profile?.Name}</h6>
          </div>
          <div className={styles.receiptDetails}>
            <label>Reference Number</label>
            <h6>{data.PaymentReference}</h6>
          </div>
          <div className={styles.receiptDetails}>
            <label>Amount</label>
            <h6>{formatCurrency(data.Amount, "NGN")}</h6>
          </div>
          <div className={styles.receiptDetails}>
            <label>Purpose</label>
            <h6>{data.PaymentAction}</h6>
          </div>
          <div className={styles.receiptDetails}>
            <label>Status</label>
            <h6>{data.PaymentStatus}</h6>
          </div>
        </div>
        <div className={styles.note}>
          <p>
            Note: This Official Receipt is system-generated and does not require
            a signature.
          </p>
          <p>
            For further details please contact us at{" "}
            <a href="mailto:finance@cipmnigeria.org" className={styles.link}>
              finance@cipmnigeria.org
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default PaymentReceipt;
